import {
    CustomerLandingPageRelayQuery,
    getCustomerLandingPageRelayQueryVars
} from "src/contentful/graphql/customer-landing-page";

import { init as initRelay } from "../../init-relay-streaming";
import { CustomersLandingPage } from "../../pages/customers/customers-landing-page";
const relayApi = "contentful";

initRelay(
    CustomersLandingPage,
    CustomerLandingPageRelayQuery,
    getCustomerLandingPageRelayQueryVars(window.location),
    relayApi
);
